<template>
  <v-row>
    <v-col cols="12"
      ><b>{{ $t("task.lblMeetingTask") }}</b>
    </v-col>
    <v-col cols="5">
      <v-card>
        <v-toolbar color="secondary" dense elevation="0">
          <span>{{ $t("meetings") }}</span>
          <v-spacer></v-spacer>
          <meeting-filter
            :btn-text="true"
            @isLoader="isLoader"
            :isSmall="true"
          ></meeting-filter>
        </v-toolbar>
        <v-skeleton-loader
          height="200"
          v-if="loaderLoading"
          type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item"
        ></v-skeleton-loader>
        <v-list
          v-else
          two-line
          dense
          height="200"
          class="meeting-list list-margin pt-0"
          style="overflow: auto"
        >
          <v-list-item-group :value="slectedMeetings" color="primary" multiple>
            <template v-for="(meetingItem, index) in sortedMeetingData">
              <v-list-item
                :key="`${meetingItem.meetingName}_${index}`"
                :value="meetingItem.id"
                style="min-height: 40px !important"
                @click="onSelectMeeting(meetingItem)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    meetingItem.meetingName
                  }}</v-list-item-title>

                  <v-list-item-subtitle class="text--primary">
                    {{
                      getDay(meetingItem.scheduletStartTimeInUTC)
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index < sortedMeetingData.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
    <v-col cols="2" class="d-flex justify-center align-center">
      <v-tooltip v-if="$security.checkUserAccess('CreateTask')" bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            :disabled="isAddButtonDisabled"
            color="primaryDark"
            v-bind="attrs"
            v-on="on"
            @click="onAddTaggedMeetings"
            >{{ $t("btnAdd")
            }}<v-icon class="ml-2" size="16">mdi-transfer-right</v-icon>
          </a-btn>
        </template>
        <span>{{ $t("task.lblAddTooltip") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="5">
      <v-card>
        <v-toolbar color="secondary" dense elevation="0">
          <span>{{ $t("task.lblTaggedMeetings") }}</span>
        </v-toolbar>
        <v-skeleton-loader
          height="200"
          v-if="loaderLoading"
          type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item"
        ></v-skeleton-loader>
        <v-list
          v-else
          two-line
          dense
          height="200"
          class="meeting-list list-margin pt-0"
          style="overflow: auto"
        >
          <template v-for="(meetingItem, index) in selectedMeetingList">
            <v-list-item
              :key="`${meetingItem.id}_${index}`"
              :value="meetingItem"
              style="min-height: 40px !important"
            >
              <v-list-item-content>
                <v-list-item-title class="primary--text">{{
                  meetingItem.meetingName
                }}</v-list-item-title>

                <v-list-item-subtitle>
                  {{
                    getDay(meetingItem.scheduletStartTimeInUTC)
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1"
                      @click="removeSelectedMettings(meetingItem.id)"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('task.tipRemoveSelectedMeeting') }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < sortedMeetingData.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MeetingFilter from "../agenda/MeetingFilter.vue";
import { cloneDeep, remove } from "lodash";

export default {
  name: "MeetingsList",
  components: { MeetingFilter },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loaderLoading: false,
      unSavedMeetings: [],
      savedMeetingList: [],
    };
  },
  computed: {
    ...mapState({
      meetingListData: (state) => state.meeting.meetingsList,
    }),
    sortedMeetingData() {
      return this.meetingListData.sort((a, b) => {
        return (
          new Date(a.scheduletStartTimeInUTC).getTime() -
          new Date(b.scheduletStartTimeInUTC).getTime()
        );
      });
    },
    slectedMeetings() {
      return this.value.map((item) => item.id);
    },
    selectedMeetingList() {
      return this.savedMeetingList.sort((a, b) => {
        return (
          new Date(a.scheduletStartTimeInUTC).getTime() -
          new Date(b.scheduletStartTimeInUTC).getTime()
        );
      });
    },
    isAddButtonDisabled() {
      return !this.unSavedMeetings.length;
    },
  },
  async mounted() {
    this.loaderLoading = true;
    await this.getMeetingListApi();
    this.unSavedMeetings = cloneDeep(this.value);
    this.savedMeetingList = cloneDeep(this.value);
    this.loaderLoading = false;
  },
  watch: {
    value(meetings) {
      this.unSavedMeetings = cloneDeep(meetings);
    },
  },
  methods: {
    ...mapActions({
      getMeetingListApi: "meeting/getMeetingList",
    }),
    getDay,
    isLoader,
    removeSelectedMettings,
    onAddTaggedMeetings,
    onSelectMeeting,
  },
};

function onSelectMeeting(item) {
  const isMeetingUnsaved = this.unSavedMeetings.some((m) => m.id === item.id);
  if (isMeetingUnsaved) {
    this.unSavedMeetings = remove(
      this.unSavedMeetings,
      (n) => n.id !== item.id
    );
  } else {
    const unsavedMeeting = extractMeetingData(item);
    this.unSavedMeetings.push(unsavedMeeting);
  }
}

function onAddTaggedMeetings() {
  this.savedMeetingList = [];
  this.savedMeetingList = cloneDeep(this.unSavedMeetings);
  this.$emit("input", this.savedMeetingList || []);
}

function removeSelectedMettings(id) {
  this.savedMeetingList = this.savedMeetingList
    .filter((item) => item.id !== id)
    .map(extractMeetingData);
  this.$emit("input", this.savedMeetingList || []);
}

function extractMeetingData(item) {
  const { id, meetingName, meetingTypeId, scheduletStartTimeInUTC } = item;
  return {
    id,
    meetingName,
    meetingTypeId,
    scheduletStartTimeInUTC,
  };
}

function isLoader(status) {
  this.loaderLoading = status;
}

function getDay(meetingdate) {
  let Xmas95 = new Date(meetingdate);
  let options = { dateStyle: "full", timeStyle: "short" };
  return new Intl.DateTimeFormat(this.$i18n.locale, options).format(Xmas95);
}
</script>

<style scoped>
::v-deep .btn-gray-theme {
  border: 1px solid #999999;
}
</style>